import { ApiConfig } from "../../Config/ApiConfig";
import {EMAILTEMPLATEGET , EMAILTEMPLATEDETAILS , EMAILTEMPLATEUPDATE } from '../../Constants/EmailTemplate'
import { createFormDataAction, createPostDataAction } from "./CommonAction";



export const EmailtemplateGetAction = (payload:any) => createPostDataAction(EMAILTEMPLATEGET, ApiConfig?.EmailtemplateLiist,payload,false );
export const EmailtemplateDetailAction =(payload:any)=>createPostDataAction(EMAILTEMPLATEDETAILS , ApiConfig?.EmailtemplateDetails,payload,false)
export const EmailtemplateUpdateAction =(payload:any)=>createPostDataAction(EMAILTEMPLATEUPDATE , ApiConfig?.EmailtemplateEdit,payload , true)